import { homeSummarySchema } from '@mio/shared';
import { queryOptions } from '@tanstack/react-query';

import { apiRequest } from '../client';

/** Shared definition so the home page and the app shell read the same cached summary. */
export const homeSummaryQuery = queryOptions({
  queryKey: ['home'] as const,
  queryFn: ({ signal }) => apiRequest('/home', homeSummarySchema, { signal }),
  staleTime: 60_000,
});
